// eslint-disable-next-line import/prefer-default-export
export const incomeExpense = {
  content: '""',
  width: '15px',
  height: '10px',
  top: '5px',
  left: '-5px',
  position: 'absolute',
};
